import $ from 'jquery'
import appPrince from './callApp'

export default {
  setCookie(name, value) {
    let Days = 30
    let exp = new Date()
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie =
      name + '=' + escape(value) + '; expires=' + exp.toGMTString() + '; path=/'
  },

  getCookie(name) {
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    let arr = document.cookie.match(reg)
    if (arr) {
      return unescape(arr[2])
    } else {
      return null
    }
  },

  removeCookie(name, domain, path) {
    document.cookie =
      name +
      '=; expires=Mon, 26 Jul 1997 05:00:00 GMT; path=' +
      (path ? path : '/') +
      '; ' +
      (domain ? 'domain=' + domain + ';' : '')
  },

  clearCookie() {
    let keys = document.cookie.match(/[^ =;]+(?=\=)/g)
    if (keys) {
      for (let i = keys.length; i--; )
        document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
    }
  },
  parseQuery(link) {
    let url = link ? link : location.href
    let theRequest = {}

    if (url.indexOf('?') != -1) {
      let str = url.substr(url.indexOf('?') + 1)
      let strs = str.split('&')

      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
      }
    }

    return theRequest
  },

  isMGTV() {
    return /imgo/.test(navigator.userAgent.toLowerCase()) ? true : false
  },
  isLogin() {
    if (location.href.indexOf('debug') > -1) {
      return true
    }
    return window.USERINFO.ticket && window.USERINFO.uuid
  },
  toParam(obj) {
    let result = []
    for (let key in obj) {
      result.push(key + '=' + obj[key])
    }
    return result.join('&')
  },

  toast(msg, callback, center = false) {
    let styleArr = [
      'position: fixed',
      'left: 50%',
      'top: 100%',
      'z-index: 9999',
      'width: 60%',
      '-webkit-box-sizing: border-box;',
      'box-sizing: border-box;',
      'margin-left: -30%',
      'border-radius: 50px',
      'background: rgba(0, 0, 0, .5)',
      'font-size: 14px',
      'color: #fff',
      'text-align: center',
      'padding: 8px',
      'line-height: 18px',
      'opacity: 0',
      '-webkit-transition: all .3s ease',
    ]
    let div = document.createElement('div')
    let txt = document.createTextNode(msg)
    div.setAttribute('style', styleArr.join(';'))
    div.setAttribute('id', 'mgtoast')
    div.appendChild(txt)
    document.body.appendChild(div)

    setTimeout(() => {
      div.style.opacity = 1
      div.style.top = center ? '50%' : '75%'
    }, 200)

    setTimeout(() => {
      div.style.opacity = 0
      div.style.top = '100%'
      div.addEventListener('webkitTransitionEnd', () => {
        if (typeof callback === 'function') callback()
        $('#mgtoast').remove()
      })
    }, 2000)
  },

  zeroFill(n) {
    return parseInt(n) < 10 ? '0' + n : n
  },

  rnd(m, n) {
    return Math.floor((n - m) * Math.random() + m)
  },

  getYMD(value) {
    var date = new Date()
    if (value) {
      date = new Date(value)
    }
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()

    return (
      this.zeroFill(year) +
      '-' +
      this.zeroFill(month) +
      '-' +
      this.zeroFill(day)
    )
  },

  getYMDHMS: function(value) {
    var date = new Date()
    if (value) {
      date = new Date(value)
    }
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var min = date.getMinutes()
    var sec = date.getSeconds()

    return (
      '' +
      this.zeroFill(year) +
      this.zeroFill(month) +
      this.zeroFill(day) +
      this.zeroFill(hour) +
      this.zeroFill(min) +
      this.zeroFill(sec)
    )
  },

  //站内并且不是schema则用端上的跳转方法打开新的webview
  jumpPage(url) {
    let ua = navigator.userAgent.toLowerCase()
    if (/imgo/.test(ua) && url.indexOf('imgotv://') == -1) {
      MgtvApi.jumpPage({ url: url })
    } else {
      setTimeout(() => {
        window.location = url
      }, 300)
    }
  },

  //随机生成uuid
  uuid() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'

    var uuid = s.join('')
    return uuid
  },

  //检查微博,微博无法唤起,显示遮罩
  checkWeibo() {
    var ua = navigator.userAgent.toLowerCase()
    let _this = this
    var isWeibo = /weibo/.test(ua)
    if (isWeibo) {
      if (!document.getElementById('weiboMask')) {
        var weiboMask = document.createElement('div')
        weiboMask.id = 'weiboMask'
        document.body.append(weiboMask)
        var weiboMaskDom = document.getElementById('weiboMask')
        weiboMaskDom.onclick = function() {
          weiboMaskDom.style.display = 'none'
        }
      } else {
        document.getElementById('weiboMask').style.display = 'block'
      }
    }
    return isWeibo
  },
  // M站同版唤起 2020-02-05
  callApp(callURL) {
    if (this.checkWeibo()) {
      return false
    }
    const targetUrl = callURL || location.href
    const channelRCH = 'hitv' //唤起数据上报用于区分渠道
    const jumpSchema = `imgotv://webview?from=${channelRCH}&url=${encodeURIComponent(targetUrl)}`

    appPrince.kiss({
      schemaUrl: jumpSchema,
      tencentUrl:
        'http://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ckey=CK1449084199069&ios_scheme=' +
        encodeURIComponent(jumpSchema) +
        '&android_schema=' +
        encodeURIComponent(jumpSchema),
      itunesUrl:
        'https://itunes.apple.com/app/apple-store/id629774477?pt=355474&ct=mg12&mt=8',
      andriodUrl: 'https://mobile.api.mgtv.com/thridGetApk?code=c103801',
      targetUrl,
    })
  },
  //微信二次分享信息设置
  setWXShareInfo(params, callback) {
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
      // 设置微信分享
      $.ajax({
        url: 'https://vs.api.mgtv.com/weixin/sign',
        type: 'get',
        dataType: 'jsonp',
        data: {
          url: location.href.split('#')[0],
        },
        timeout: 10000,
      }).done(resp => {
        if (resp.status === 200) {
          wx.config({
            debug: false,
            appId: resp.data.appId,
            timestamp: resp.data.timestamp,
            nonceStr: resp.data.nonceStr,
            signature: resp.data.signature,
            jsApiList: [
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareQZone',
            ],
          })
          wx.ready(function() {
            const paramsObject = {
              type: 'link',
              title: params.title,
              desc: params.desc,
              link: params.shareUrl,
              imgUrl: params.shareIcon,
              success: function() {
                callback && callback()
              },
            }
            wx.onMenuShareTimeline(paramsObject)
            wx.onMenuShareAppMessage(paramsObject)
            wx.onMenuShareQQ(paramsObject)
            wx.onMenuShareQZone(paramsObject)
          })
        }
      })
    } else if (/qq/.test(navigator.userAgent.toLowerCase())) {
      // 设置QQ分享
      setShareInfo({
        title: params.title,
        summary: params.shareDesc,
        url: params.shareUrl || location.href,
        pic:
          params.shareIcon || 'http://i2.hitv.com/p1/20180502/1513461816.png',
      })
    }
  },
  // 跳转登录
  jumpLogin() {
    if (this.isMGTV()) {
      MgtvApi.login(resp => {
        location.reload()
      })
    } else {
      this.removeCookie('HDCN', 'mgtv.com')
      this.removeCookie('uuid', 'mgtv.com')
      setTimeout(() => {
        window.location.href =
          'https://m.mgtv.com/login/?from=' +
          encodeURIComponent(window.location.href)
      }, 300)
    }
  },
  // 获取元素到页面顶部高度
  getElementTop(id) {
    let el = document.getElementById(id)
    if (!el) {
      console.log('getElementTop NULL')
      return 0
    }
    var actualTop = el.offsetTop
    var current = el.offsetParent
    while (current !== null) {
      actualTop += current.offsetTop
      current = current.offsetParent
    }
    return actualTop
  },

  //统一判断站外是否唤起到App
  outsiteCallToAPP() {
    //线上环境并且url中没有login跳转,否则不跳转
    return location.href.indexOf('app.mgtv') > -1 &&
      location.href.indexOf('login') == -1
      ? true
      : false
  },
  base64ToBlob(base64) {
    var arr = base64.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new Blob([u8arr], { type: mime })
  },

  //按照key ascii排序并排列
  sortASCIIandStringfy(obj) {
    let arr = new Array()
    let num = 0
    let stringifyStr = ''
    for (let i in obj) {
      arr[num] = i
      num++
    }
    let sortArr = arr.sort()
    let sortObj = {}
    for (let i in sortArr) {
      sortObj[sortArr[i]] = obj[sortArr[i]]
    }
    for (let i in sortObj) {
      stringifyStr = `${stringifyStr}${i}=${sortObj[i]}&`
    }
    return stringifyStr
  },
}
